/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray, oneOf as codecOneOf } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CommentReplyEdit, CreateCommentData, CreateCommentReplyData, DeletedCommentReply, ExtendedNonDeletedCommentReply, GeneralFeedbackCommentBaseWithExtendedReplies, InlineFeedbackCommentBaseWithExtendedReplies, PatchCommentReplyData, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function comment(config) {
    const createBaseResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['inline-feedback', InlineFeedbackCommentBaseWithExtendedReplies],
            ['general-feedback', GeneralFeedbackCommentBaseWithExtendedReplies],
        ]))),
    });
    const createReplyResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([ExtendedNonDeletedCommentReply, DeletedCommentReply]))),
    });
    const deleteReplyResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const patchReplyResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([ExtendedNonDeletedCommentReply, DeletedCommentReply]))),
    });
    const getAllReplyEditsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CommentReplyEdit))),
    });
    const disapproveReplyResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([ExtendedNonDeletedCommentReply, DeletedCommentReply]))),
    });
    const approveReplyResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([ExtendedNonDeletedCommentReply, DeletedCommentReply]))),
    });
    return Object.freeze({
        /**
         * Create a new comment base, or retrieve an existing one.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The just created comment base.
         */
        createBase: async ({ requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/comments/`, createBaseResponse.v, JSON.stringify(CreateCommentData.encode(requestBody)));
            return result;
        },
        /**
         * Add a reply to a comment base.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The id of the base to which you want to add a reply.
         * @param arg.requestBody The body of the request.
         * @returns The just created reply.
         */
        createReply: async ({ commentBaseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/comments/${commentBaseId}/replies/`, createReplyResponse.v, JSON.stringify(CreateCommentReplyData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the given reply.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The base of the given reply.
         * @param arg.replyId The id of the reply to delete.
         * @returns Nothing.
         */
        deleteReply: async ({ commentBaseId, replyId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/comments/${commentBaseId}/replies/${replyId}`, deleteReplyResponse.v, undefined);
            return result;
        },
        /**
         * Update the content of a reply.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The base of the given reply.
         * @param arg.replyId The id of the reply for which you want to update.
         * @param arg.requestBody The body of the request.
         * @returns The just updated reply.
         */
        patchReply: async ({ commentBaseId, replyId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/comments/${commentBaseId}/replies/${replyId}`, patchReplyResponse.v, JSON.stringify(PatchCommentReplyData.encode(requestBody)));
            return result;
        },
        /**
         * Get the edits of a reply.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The base of the given reply.
         * @param arg.replyId The id of the reply for which you want to get the edits.
         * @returns A list of edits, sorted from newest to oldest.
         */
        getAllReplyEdits: async ({ commentBaseId, replyId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/comments/${commentBaseId}/replies/${replyId}/edits/`, getAllReplyEditsResponse.v, undefined);
            return result;
        },
        /**
         * Update the approval status of a reply.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The base of the given reply.
         * @param arg.replyId The id of the reply for which you want to update the approval.
         * @returns The just updated reply.
         */
        disapproveReply: async ({ commentBaseId, replyId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/comments/${commentBaseId}/replies/${replyId}/approval`, disapproveReplyResponse.v, undefined);
            return result;
        },
        /**
         * Update the approval status of a reply.
         *
         * @param arg The arguments to the function.
         * @param arg.commentBaseId The base of the given reply.
         * @param arg.replyId The id of the reply for which you want to update the approval.
         * @returns The just updated reply.
         */
        approveReply: async ({ commentBaseId, replyId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/comments/${commentBaseId}/replies/${replyId}/approval`, approveReplyResponse.v, undefined);
            return result;
        },
    });
}
